import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';

import { useDispatch } from 'react-redux';
import { TechRsltListBox } from '../../components/techSupports/TechRsltListBox';
import { listRsltTechs } from '../../modules/techModule/techRslts';

const RsltTechSearchContainer = ({ add }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAdd = () => {
    navigate(`/rslttechmng/add`);
  };

  const initialValues = {
    searchKeyword: 'rsltNo',
    searchWords: '',
    searchStrtDt: '',
    searchEndDt: '',
  };

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '등록 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('등록 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      //   setSubmitting(true);
      const startDate =
        values.searchStrtDt !== null
          ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
          : '';
      const endDate =
        values.searchEndDt !== null
          ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
          : '';

      let searchData = {
        [values.searchKeyword]: values.searchWords,
        strtDt: startDate,
        endDt: endDate,
      };

      setTimeout(() => {
        // alert(JSON.stringify(values, null, 2));
        dispatch(listRsltTechs(searchData));
        // formik.resetForm();
        setSubmitting(false);
      }, 1000);
    },
  });

  return <TechRsltListBox formik={formik} handleAdd={handleAdd} />;
};

export default RsltTechSearchContainer;
